import { render, staticRenderFns } from "./jobrecord.vue?vue&type=template&id=8722a6e0&"
import script from "./jobrecord.vue?vue&type=script&lang=js&"
export * from "./jobrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports